import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import SegmentAnalyticsMixin from '../helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import TheFooter from '../components/Footer.vue';
import GetStarted from '../components/GetStarted.vue';
import Awards from '../components/Awards.vue';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import { S3_ASSETS_BUCKET_URL } from '../helpers/constants/LandingPage';
let AboutUs = class AboutUs extends Mixins(SegmentAnalyticsMixin, ViewportSizeMixin) {
    get chatgenieLogo() {
        return `${S3_ASSETS_BUCKET_URL}/chatgenie-logo-landing-beta.png`;
    }
    get paragraphs() {
        return [
            `The “Chat” in ChatGenie is a remnant
       on how we evolve from being a chatbot provider to a frictionless sales channel platform 
       on Messenger.`,
            `Our current approach to eCommerce might be different from our chatbot days where we are using
       automated responses to facility an online transaction but our vision stays the same. Our vision
       was still to be the go-to platform for businesses and retailers that are looking to sell where
       their customers are. It might be on Messaging apps like Facebook Messenger, Viber, Line,
       WhatsApp; short-form video sharing platforms like Tiktok, or mobile wallet apps like PayTM,
       Alipay, GCash, PayMaya.`,
            `Our team is confident that the most efficient eCommerce Sales Channel strategy 
        is to sell on Mobile Apps that are already installed on customer’s mobile phones.
        Businesses in China are already doing this via WeChat and Alipay Mini Programs and businesses
        in India are starting to embrace this with PayTM Mini Programs.`,
            `We believe that in the next few years ChatGenie will play a big role
       in accelerating this trend across in Southeast Asia region and North America.`,
        ];
    }
    mounted() {
        this.segmentTrack('Chatgenie Website Visit');
    }
};
AboutUs = __decorate([
    Component({
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.$store.state.displayHomeNav = true;
                return true;
            });
        },
        components: {
            TheFooter,
            GetStarted,
            Awards,
        },
    })
], AboutUs);
export default AboutUs;
